/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Deep_Gray_Bee_HikeInputs */

const en_deep_gray_bee_hike = /** @type {(inputs: Deep_Gray_Bee_HikeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email`)
};

const de_deep_gray_bee_hike = /** @type {(inputs: Deep_Gray_Bee_HikeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-Mail`)
};

/**
* | output |
* | --- |
* | "Email" |
*
* @param {Deep_Gray_Bee_HikeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const deep_gray_bee_hike = /** @type {((inputs?: Deep_Gray_Bee_HikeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deep_Gray_Bee_HikeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_deep_gray_bee_hike(inputs)
	return de_deep_gray_bee_hike(inputs)
});